import { api } from '../api.ts';
import { html, mount } from '../html.ts';
import { t } from '../i18n.ts';
import { canWrite } from '../state.ts';
import { toastError } from '../ui.ts';

const SYSTEMS: Record<string, string> = { beads: 'Beads', jira: 'Jira', github: 'GitHub', gitlab: 'GitLab', agentops: 'AgentOps', other: 'Andere' };
const systemLabel = (system: string) => (system === 'other' ? t('Andere') : SYSTEMS[system] ?? system);

/** Links to records in other systems, with an inline add form (no nested form elements). */
export async function renderLinks(target: HTMLElement, entityType: string, entityId: string): Promise<void> {
  const { items } = await api.get<{ items: any[] }>(`/external-links?entity_type=${entityType}&entity_id=${entityId}`);
  mount(
    target,
    html`<fieldset class="p-fieldset pma-links"><legend class="p-label">${t('Verknüpfungen')}</legend>
      ${items.length ? html`<ul class="pma-links__list">${items.map(
        (l) => html`<li><span class="p-badge">${systemLabel(l.system)}</span>
          ${l.url ? html`<a href="${l.url}" target="_blank" rel="noopener noreferrer">${l.title ?? l.external_id}</a>` : html`<span>${l.title ?? l.external_id}</span>`}
          ${canWrite() ? html`<button type="button" class="p-button p-button--ghost p-button--sm" data-unlink="${l.id}" aria-label="${t('Verknüpfung {id} entfernen', { id: l.external_id })}">×</button>` : ''}</li>`,
      )}</ul>` : html`<p class="pma-muted pma-small">${t('Keine Verknüpfungen zu Beads, Jira, GitHub oder AgentOps.')}</p>`}
      ${canWrite() ? html`<div class="pma-inline-add">
        <select class="p-select" data-p-size="sm" data-link-system aria-label="${t('System')}">${Object.keys(SYSTEMS).map((v) => html`<option value="${v}">${systemLabel(v)}</option>`)}</select>
        <input class="p-input" data-p-size="sm" data-link-id placeholder="${t('ID, z. B. pma-42')}" aria-label="${t('Externe ID')}" maxlength="200">
        <input class="p-input" data-p-size="sm" data-link-url type="url" placeholder="${t('https://… (optional)')}" aria-label="${t('Link')}">
        <button type="button" class="p-button p-button--sm" data-link-add>${t('Verknüpfen')}</button></div>` : ''}
    </fieldset>`,
  );
  target.onclick = async (event) => {
    const element = event.target as HTMLElement;
    try {
      const unlink = element.closest<HTMLElement>('[data-unlink]')?.dataset.unlink;
      if (unlink) {
        await api.delete(`/external-links/${unlink}`);
        await renderLinks(target, entityType, entityId);
      }
      if (element.closest('[data-link-add]')) {
        const externalId = target.querySelector<HTMLInputElement>('[data-link-id]')!.value.trim();
        const url = target.querySelector<HTMLInputElement>('[data-link-url]')!.value.trim();
        if (!externalId) return;
        await api.post('/external-links', {
          entity_type: entityType,
          entity_id: entityId,
          system: target.querySelector<HTMLSelectElement>('[data-link-system]')!.value,
          external_id: externalId,
          ...(url ? { url } : {}),
        });
        await renderLinks(target, entityType, entityId);
      }
    } catch (error) {
      toastError(error);
    }
  };
}
